import { Component, OnInit } from '@angular/core';
import { FormSessionCanDeactivate } from '../../shared';

@Component({
  selector: 'app-snfpatient',
  templateUrl: './snfpatient.component.html',
  styleUrls: ['./snfpatient.component.css']
})
export class SnfpatientComponent extends FormSessionCanDeactivate {

  constructor() {
    super();
  }

  ngOnInit() {
  }

}
